import { render, staticRenderFns } from "./monitoring-appointments.vue?vue&type=template&id=578c9c4c&scoped=true"
import script from "./monitoring-appointments.vue?vue&type=script&lang=js"
export * from "./monitoring-appointments.vue?vue&type=script&lang=js"
import style0 from "./monitoring-appointments.vue?vue&type=style&index=0&id=578c9c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c9c4c",
  null
  
)

export default component.exports